Vue.filter('prettifyEmail', function(value) {
	return value.replace(/[@.]/g, '')
});
